module.exports = __webpack_public_path__ + "img/OnTheRoad.c22b1714.jpg";